import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';

const DEFAULT_OBJECT = {};
const DEFAULT_ARRAY = [];

const getUserStore = (state) => state?.userReducer || DEFAULT_OBJECT;

export const getUserSelector = createSelector([getUserStore], (userReducer) => {
  const result = userReducer?.user;
  return isEmpty(result) ? DEFAULT_OBJECT : result;
});

export const getUserIdSelector = createSelector(
  [getUserSelector],
  (user) => user?._id,
);

export const getUserRolesSelector = createSelector(
  [getUserSelector],
  (user) => {
    const result = user?.roles;
    return isEmpty(result) ? DEFAULT_ARRAY : result;
  },
);

export const isWorkfloSuperAdminSelector = createSelector(
  [getUserRolesSelector],
  (roles) => roles?.includes('workfloSuperAdmin'),
);
